// Where to send the user once they finish signing in.
//
// Deep links out of our emails (e.g. the missed-call follow-up, which points at one
// filtered lead) land on a protected route. When nobody is signed in, AuthLayout bounces
// them to /login and the target would otherwise be lost - so we park it here first and
// authContext reads it back after a successful login.
//
// sessionStorage, not router state: the OTP step and the "keep me logged in" reload both
// remount the tree, and router state does not survive that.

const REDIRECT_KEY = 'postLoginRedirect';

// Only same-origin app paths are ever stored, so a tampered value cannot send the user
// off to another site after login.
const isSafeAppPath = (path) =>
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');

export const saveRedirectPath = (path) => {
  if (!isSafeAppPath(path)) return;
  // Nothing to come back to - these are the login screens themselves.
  if (path === '/' || path.startsWith('/login')) return;
  try {
    window.sessionStorage.setItem(REDIRECT_KEY, path);
  } catch (e) {
    // Private mode / storage disabled - fall back to the normal post-login home.
  }
};

// Reads the parked path and clears it, so a later plain login goes to the usual home.
export const takeRedirectPath = () => {
  try {
    const path = window.sessionStorage.getItem(REDIRECT_KEY);
    window.sessionStorage.removeItem(REDIRECT_KEY);
    return isSafeAppPath(path) ? path : null;
  } catch (e) {
    return null;
  }
};
